export default __webpack_public_path__ + "static/media/image_3.45aa0b61.jpg";